import * as actionTypes from './actionTypes';

export const initialOrderWriteState = {
  status: false,
  isOrderWriteSuccess: false,
  isOrderWriteError: false,
  isInvalidCaseId: false,
  isPaymentsNeeded: false,
  errorId: '',
};

function OrderWriteReducer(state = initialOrderWriteState, action) {
  switch (action.type) {
    case actionTypes.RESET_ORDER_WRITE:
      return { ...state, ...initialOrderWriteState };

    case actionTypes.ORDER_WRITE_SUCCESS:
      return { ...state, status: true, isOrderWriteSuccess: true, isOrderWriteError: false, isInvalidCaseId: false, isPaymentsNeeded: false };

    case actionTypes.ORDER_WRITE_FAILURE:
      return {
        ...state,
        status: true,
        isOrderWriteSuccess: false,
        isOrderWriteError: true,
        isInvalidCaseId: action.data?.isInvalidCaseId || false,
        isPaymentsNeeded: action.data?.isPaymentsNeeded || false,
        errorId: action.data?.errorId || '',
      };

    default:
      return state;
  }
}

export default OrderWriteReducer;
